import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_public')({
  beforeLoad: ({ context, location }) => {
    if (context.auth.isAuthenticated && location.pathname === '/login') {
      throw redirect({ to: '/' });
    }
  },
  component: () => <Outlet />,
});
